import type { FC, PropsWithChildren } from "react";
import clsx from "clsx";

import { i18n } from "@/localization";
import { useQueryConfig } from "@/api/config";

interface ContentContainerProps {
	className?: string;
}

export const RegistrationContainer: FC<PropsWithChildren<ContentContainerProps>> = ({ children, className }) => {
	const { data: config } = useQueryConfig();

	const getLoginUrl = () => {
		if (config?.genesisUrl) {
			// Ensure the genesisUrl doesn't end with a slash before appending /login
			const baseUrl = config.genesisUrl.endsWith("/") ? config.genesisUrl.slice(0, -1) : config.genesisUrl;

			return new URL(`${baseUrl}/login`).href;
		}

		return undefined;
	};

	return (
		<div className={clsx("relative flex min-h-dvh w-full flex-col px-4", "bg-auth", className)}>
			<div className={clsx("bg-brand-light-900 borde rounded-3xl", "mx-auto mt-6 max-w-250 lg:mt-20")}>
				{children}
			</div>
			{getLoginUrl() ? (
				<p className="text-brand-dark/70 mt-8 mb-20 text-center text-sm leading-5">
					{i18n("wizard.footer.alreadyRegistered")}{" "}
					<a href={getLoginUrl()} className="text-brand-primary-900 font-medium hover:underline">
						{i18n("wizard.footer.loginNow")}
					</a>
				</p>
			) : null}
		</div>
	);
};
